export function metadataEntityFieldValue(tag, field) {
    return metadataEntityFieldValues(tag, field).join(", ");
}

export function metadataEntityFieldValues(tag, field) {
    return (tag?.metadata_custom_meta_values || [])
        .filter(value => value.custom_meta_field_id === field.id)
        .map(value => [value.value, value.text, value.number, value.date]
            .find(candidate => candidate !== null && candidate !== undefined && candidate !== ""))
        .filter(value => value !== null && value !== undefined && value !== "");
}

export function orderedMetadataEntityFields(type) {
    if (!type) return [];
    const custom = [...(type.custom_meta_groups || []).flatMap(group => (group.custom_meta_group?.custom_meta_fields || []).map(entry => entry.custom_meta_field)), ...(type.custom_meta_fields || []).map(entry => entry.custom_meta_field)].filter(Boolean);
    const fields = new Map();
    (type.standard_fields || []).forEach(field => fields.set(`standard:${field.key}`, {key: `standard:${field.key}`, standard: field}));
    custom.forEach(field => fields.set(`custom:${field.id}`, {key: `custom:${field.id}`, custom: field}));
    const keys = type.schema_fields?.map(field => field.key) || [...fields.keys()];
    return keys.map(key => fields.get(key)).filter(Boolean);
}

export function metadataEntityStandardFieldValue(tag, field) {
    const value = tag?.metadata_entity_standard_values?.[field.key];
    return Array.isArray(value) ? value.filter(item => item !== null && item !== undefined && item !== '').join(', ') : value;
}
